// @core/api/endpoints/userprofile/list_avatars_by_owner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAvatarsResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List avatars by owner
 * Returns all avatars owned by a specific entity. Useful for retrieving avatars when the profile ID is not directly available.
 */
export async function ListAvatarsByOwner(
  owner_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAvatarsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/avatars/owner/:owner_id`;
  requestPath = requestPath.replace(':owner_id', encodeURIComponent(owner_id));
  const requestOptions = options;
  return client.get<ListAvatarsResponse>(requestPath, { ...requestOptions, params });
}
